import {
  ExtractFnReturnType,
  InfiniteQueryConfigType,
  useInfiniteQuery,
  UseInfiniteQueryResult,
} from "~/libs";

import { ApiClient } from "~/utils";

import { ApisAdminOperatorsCompaniesBillingPeriodLogsIndexResponseType } from "~/domains";

type RequestDataType = {
  page?: number;
  companyId: string;
};

const request = async ({
  page = 1,
  companyId,
}: RequestDataType): Promise<ApisAdminOperatorsCompaniesBillingPeriodLogsIndexResponseType> => {
  const response =
    await new ApiClient().get<ApisAdminOperatorsCompaniesBillingPeriodLogsIndexResponseType>(
      `/api/admin_operators/companies/${companyId}/billing_period_logs`,
      { page },
    );
  return response.data;
};

type QueryFnType = typeof request;

type PropsType = {
  config?: InfiniteQueryConfigType<QueryFnType>;
  companyId: string;
};

export const useApisAdminOperatorsCompaniesBillingPeriodLogsIndex = ({
  companyId,
  config = {},
}: PropsType): UseInfiniteQueryResult<ApisAdminOperatorsCompaniesBillingPeriodLogsIndexResponseType> => {
  return useInfiniteQuery<ExtractFnReturnType<QueryFnType>>(
    ["ApisAdminOperatorsCompaniesBillingPeriodLogsIndex", companyId],
    ({ pageParam }) => {
      return request({ companyId, page: pageParam as number | undefined });
    },
    {
      ...config,
      getNextPageParam: (data) => {
        return data.pagy.hasMore ? data.pagy.currentPage + 1 : false;
      },
    },
  );
};
